import { Box } from "@mui/material"
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import { useCallback } from "react"
import { useLocation } from "react-router"
import { s } from "src/utilities/common"
import { theme, TI } from "src/utilities/theme"

import { DGText } from "../../../components/common/DGText"
import { useSmoothNavigate } from "../../../hooks/use-smooth-navigate"
import { ArrayElement } from "../../../types"
import { DetailPage } from "../DetailStore"

export const CategoryLinks = ({
  page,
  addFocus,
}: {
  page: DetailPage
  addFocus: () => void
}) => {
  const { ref, focusKey } = useFocusable({
    isFocusBoundary: true,
    focusBoundaryDirections: ["up", "left", "right"],
  })

  return (
    <FocusContext.Provider value={focusKey}>
      <Box
        ref={ref}
        sx={{
          width: "100%",
          alignItems: "flex-start",
          position: "absolute",
          left: s("96px"),
          top: s("80px"),
          display: "flex",
          flexDirection: "row",
          "& > :not(:last-child)": {
            mr: s("12px"),
          },
        }}
      >
        {page.links?.map((link) => (
          <Button
            addFocus={addFocus}
            key={"categorybutton" + page.id + link.id}
            link={link}
          ></Button>
        ))}
      </Box>
    </FocusContext.Provider>
  )
}

const Button = ({
  link,
  addFocus,
}: {
  link: ArrayElement<Exclude<DetailPage["links"], undefined>>
  addFocus: () => void
}) => {
  const navigate = useSmoothNavigate()
  const location = useLocation()
  const onEnterPress = useCallback(() => {
    addFocus()
    navigate(`../detail/${link.type}/${link.id}/0/0/0`)
  }, [link, navigate])
  const { ref, focused, focusSelf } = useFocusable({
    focusKey: "categorylink" + location + link.id,
    onEnterPress,
  })
  return (
    <Box
      tabIndex={0}
      aria-label={link.title}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={() => onEnterPress()}
      ref={ref}
      sx={{
        height: s("56px"),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.new.categoryButton,
        borderRadius: "9999px",
        pl: s("20px"),
        pr: s("20px"),
        boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.4)",
        zIndex: focused ? 2 : 1,
        transform: focused ? "scale(1.22)" : undefined,
      }}
    >
      <DGText tx={TI.new_medium06tv} sx={{ color: theme.palette.white.main }}>
        {link.title}
      </DGText>
    </Box>
  )
}
